const MAIN_FUNCTION_TYPE_CODE = {
  COMMON: '10',
  MAIN: '20',
};

const MAIN_FUNCTION_CODE = {
  ALLIANCE_BAR: '11',
  SEARCH_PHRASE: '13',
  POPULAR_SEARCH_CONTENT: '14',
  GNB: '12',
  AD_BANNER: '70',
  BEST_BRAND: '80',
  EMPLOYEE_BENEFIT: '50',
  ALLIANCE_BANNER: '71',
  POPUP_BANNER_LARGE: '72',
  POPUP_BANNER_SMALL: '73',
  POPUP_BANNER_BOTTOM: '78',
  POPUP_BANNER_LOGIN: '79', // 로그인팝업
  POPUP_BANNER_EXHIBIT: '99', //sdi전용기획전일때 popup띄우기위해 전용으로 만듦
  POPUP_BANNER_EXHIBIT_SECONDARY: '98', //sdi전용기획전일때 popup띄우기위해 전용으로 만듦2
  CUSTOM: '10',
  TODAY_SALE: '20',
  WEEKLY_SALE: '21',
  BEST_REVIEW: '30',
  SAMSUNG_FAMILY: '40',
  NEW_ITEM: '60',
  BEST_ITEM: '61', // HOT&BEST! 이 상품들이 가장 잘 나가요
  HERO_BANNER: '74',
  STRIP_BANNER_COMMON: '75',
  STRIP_BANNER_ONE: '76',
  STRIP_BANNER_TWO: '77',
  RECOMMEND_BRAND: '81',
  EXHIBITION: '90',
  MD_PICK: '91',
  GOOD_ONE: '93', // 상품호출1
  GOOD_TWO: '94', // 상품호출2
  GOOD_THREE: '95', // 상품호출3
  GOOD_FOUR: '96', // 상품호출4
  GOOD_FIVE: '97', // 상품호출5
  EVENT_MALL: '29',
  GATE_PAGE: '31',
};

const BEST_ITEM_CLASS_CODE = {
  VIEW: '10', // 많이 본 상품
  ORDER: '20', // 많이 구매한 상품
  BRAND: '30', // 브랜드 인기상품
  REAL_TIME: '40',
};

const DISPLAY_TYPE_CODE = {
  HORIZONTAL: '10',
  VERTICAL: '20',
};

const CONTENTS_KIND_CODE = {
  EXHIBITION: '10', // 기획전
  EVENT: '20',  // 이벤트
};

export { MAIN_FUNCTION_TYPE_CODE, MAIN_FUNCTION_CODE, BEST_ITEM_CLASS_CODE, DISPLAY_TYPE_CODE, CONTENTS_KIND_CODE };
